<template>
	<div>
		<div class="container">
			<div class="page page-products">
				<h3 class="title">Konfirmasi Pembayaran</h3>
				<div class="row" v-if="isLoading">
					<div class="col-md-6 col-xs-12 mb-4">
						<shimmer
							width="100%"
							height="48px"
						/>

						<shimmer
							class="mt-4"
							width="100%"
							height="300px"
						/>

						<shimmer
							class="my-4"
							width="100%"
							height="132px"
						/>
					</div>
					<div class="col-md-6 col-xs-">
						<shimmer
							width="100%"
							height="713px"
						/>
					</div>
				</div>
				<div class="row" v-else-if="privateOrder && !isLoading">
					<div class="col-md-6 col-xs-12 mb-4">
						<p>Untuk menyelesaikan proses pembayaran, silakan ikuti langkah-langkah di bawah ini. Kami akan segera memverifikasi pembayaran Anda setelah bukti diterima.</p>

						<div class="row mb-50">
							<div class="col-auto">
								<div
									class="d-flex align-items-center justify-content-center step-title"
								>
									<div>1</div>
									<div class="step-line" />
								</div>
							</div>
							<div class="col">
								<div class="text-bold">Langkah 1</div>
								<div>Isi data yang digunakan untuk transfer.</div>
							</div>
						</div>

						<div class="row mb-50">
							<div class="col-auto">
								<div
									class="d-flex align-items-center justify-content-center step-title"
								>
									<div>2</div>
									<div class="step-line" />
								</div>
							</div>
							<div class="col">
								<div class="text-bold">Langkah 2</div>
								<div>Unggah Bukti Pembayaran.</div>
							</div>
						</div>

						<div class="row mb-50">
							<div class="col-auto">
								<div
									class="d-flex align-items-center justify-content-center step-title"
								>
									<div>3</div>
								</div>
							</div>
							<div class="col">
								<div class="text-bold">Langkah 3</div>
								<div>Setelah berhasil diunggah dan data diisi, tunggu verifikasi dari kami</div>
							</div>
						</div>

						<div class="bg-white p-4 border-radius-8">
							<div>Jika ada masalah atau pertanyaan, silakan hubungi layanan pelanggan kami.</div>
							<a class="btn btn-primary mt-3" target="_blank" :href="contactUrl">
								<i class="bi bi-question-circle"></i>
								<span>Kontak Kami</span>
							</a>
						</div>
					</div>
					<div class="col-md-6 col-xs-12">
						<div class="card border-radius-8">
							<div class="card-body">
								<div class="form-group">
									<label class="text-bold">Order ID<span class="text-danger">*</span></label>
									<input
										class="form-control"
										:class="{ 'is-invalid': errorMessages.orderId }"
										type="text"
										v-model="orderId"
										disabled
									/>
									<small class="text-danger" v-if="errorMessages.orderId">{{ errorMessages.orderId }}</small>
								</div>

								<div class="form-group">
									<label class="text-bold">Atas Nama Rekening<span class="text-danger">*</span></label>
									<input
										class="form-control"
										:class="{ 'is-invalid': errorMessages.bankOwnerName }"
										type="text"
										placeholder="Nama Pemilik Rekening"
										v-model="bankOwnerName"
										@input="validateBankOwnerName"
									/>
									<small class="text-danger" v-if="errorMessages.bankOwnerName">{{ errorMessages.bankOwnerName }}</small>
								</div>

								<div class="form-group">
									<label class="text-bold">Transfer Ke<span class="text-danger">*</span></label>
									<textarea
										class="form-control"
										:class="{ 'is-invalid': errorMessages.bankAccount }"
										v-model="formatBankAccount"
										disabled
									/>
									<small class="text-danger" v-if="errorMessages.bankAccount">{{ errorMessages.bankAccount }}</small>
								</div>

								<div class="form-group">
									<label class="text-bold">Tanggal Transfer<span class="text-danger">*</span></label>
									<input
										class="form-control"
										:class="{ 'is-invalid': errorMessages.transferDate }"
										type="date"
										placeholder="Tanggal Transfer"
										:max="today"
										v-model="transferDate"
										@change="validateTransferDate"
									/>
									<small class="text-danger" v-if="errorMessages.transferDate">{{ errorMessages.transferDate }}</small>
								</div>

								<div class="form-group">
									<label class="text-bold">Jumlah Transfer<span class="text-danger">*</span></label>
									<input
										class="form-control"
										:class="{ 'is-invalid': errorMessages.transferAmount }"
										type="text"
										placeholder="Jumlah Transfer"
										v-model="transferAmount"
										disabled
									/>
									<small class="text-danger" v-if="errorMessages.transferAmount">{{ errorMessages.transferAmount }}</small>
								</div>

								<div class="form-group">
									<label class="text-bold">Bukti Transfer<span class="text-danger">*</span></label>
									<div v-if="transferEvidence">
										<div class="mb-2 w-100">
											<img :src="transferEvidence.url" class="border-grey border-radius-8" />
										</div>
										<div class="d-flex">
											<div class="text-break">
												<div class="text-bold">
													<span class="mr-2">{{ transferEvidence.name }}</span>
													<i class="bi bi-trash text-danger cursor-pointer" @click="transferEvidence = null"></i>
												</div>
												<div>
													<small><i>Original Name : {{ transferEvidence.original_name }}</i></small>
												</div>
												<small>{{ transferEvidence.size.toFixed(2) }} MB</small>
											</div>
										</div>
									</div>
									<drag-and-drop
										:is-error="errorMessages.transferEvidence.length > 0"
										:type="'image'"
										@set-url="setUrl"
										v-if="!transferEvidence"
									/>
									<small class="text-danger" v-if="errorMessages.transferEvidence">{{ errorMessages.transferEvidence }}</small>
								</div>
							</div>

							<hr class="my-0" />

							<div class="card-body">
								<button
									class="btn btn-primary btn-block"
									:class="{ 'is-loading': isSubmit }"
									:disabled="isSubmit"
									@click="submit"
								>
									Kirim
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="not-found text-center py-4" v-else-if="!privateOrder && !isLoading">
					<img src="/img/not_found.png" :width="250" alt="">
					<h3>Oops. . . Order tidak ditemukan!</h3>
					<button
						class="btn btn-primary"
						@click.prevent="back()"
					>
						{{ $t('Kembali') }}
					</button>
				</div>
			</div>
		</div>

		<main-footer />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import billingApi from '@/api/billings';
import submissionApi from '@/api/submissions';
import MainFooter from '@/components/homepages/Footer.vue';
import Shimmer from '@/components/Shimmer.vue';
import DragAndDrop from '@/components/forms/DragAndDrop.vue';
import {
	duplicateVar,
	formatFileSize,
	getAxiosErrorMessage,
} from '@/lib/helper';
import { ostockBankAccount } from '@/lib/statics';

export default {
	components: {
		MainFooter,
		Shimmer,
		DragAndDrop,
	},
	data() {
		return {
			isLoading: false,
			isSubmit: false,
			bankAccount: duplicateVar(ostockBankAccount),
			today: dayjs().format('YYYY-MM-DD'),
			transferDate: duplicateVar(this.today),
			bankOwnerName: '',
			transferEvidence: null,
			privateOrder: null,
			contactUrl: 'https://wa.me/6285280009936?&text=Halo%20%F0%9F%91%8B%2C%20Saya%20punya%20pertanyaan%20mengenai%20konfirmasi%20pembayaran',
			errorMessages: {
				orderId: '',
				bankOwnerName: '',
				bankAccount: '',
				transferDate: '',
				transferEvidence: '',
				transferAmount: '',
			},
		};
	},
	methods: {
		getPrivateOrder(loadingEnabled = true) {
			this.isLoading = loadingEnabled;

			const pid = this.$route.query.pid;

			const params = {
				pid,
			};

			const callback = (response) => {
				const result = response.data;
				if (result) {
					this.privateOrder = result;
				}
				this.isLoading = false;
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				console.log(message);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Get Wholesale Order Data',
					text: message || 'Something went wrong',
				});
				this.isLoading = false;
			};

			submissionApi.paymentConfirmationOrder(params, callback, errorCallback);
		},
		setUrl(value) {
			this.transferEvidence = value;
			this.validateTransferEvidence();
		},
		back() {
			this.$router.go(-1);
		},
		submit() {
			this.validateAllForms();
			const isErrorExist = Object.values(this.errorMessages).find(val => val !== '');
			if (isErrorExist) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Form harus diisi.',
				});
				return;
			}

			this.isSubmit = true;

			const paymentConfirmation = {
				bank_owner_name: this.bankOwnerName,
				transfer_to: this.bankAccount,
				transfer_date: this.transferDate,
				transfer_amount: Number(this.transferAmount),
				payment_receipt: this.transferEvidence?.url ?? '',
			};

			const params = {
				private_order_id: this.privateOrderId,
				order_id: this.orderId,
				payment_confirmation: JSON.stringify(paymentConfirmation),
			};

			const callback = (response) => {
				const result = response.data;
				if (result) {
					this.$router.push({
						name: 'payment-success',
					});
				}
				this.isSubmit = false;
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				console.log(message);
				this.isSubmit = false;
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Payment Confirmation',
					text: message || 'Something went wrong',
				});
			};

			billingApi.submitPaymentConfirmation(params, callback, errorCallback);
		},
		validateOrderId() {
			this.errorMessages.orderId = '';
			if (this.orderId === '') {
				this.errorMessages.orderId = 'Order ID tidak valid';
			}
		},
		validateBankOwnerName() {
			this.errorMessages.bankOwnerName = '';
			if (this.bankOwnerName === '') {
				this.errorMessages.bankOwnerName = 'Nama Pemilik Rekening wajib diisi';
			}
		},
		validateBankAcount() {
			this.errorMessages.bankAccount = '';
			if (this.bankAccount === null) {
				this.errorMessages.bankAccount = 'Rekening Tujuan tidak valid';
			}
		},
		validateTransferDate() {
			this.errorMessages.transferDate = '';
			if (this.transferDate === '') {
				this.errorMessages.transferDate = 'Tanggal Transfer wajib dipilih';
			}
		},
		validateTransferAmount() {
			this.errorMessages.transferAmount = '';
			if (this.transferAmount === '') {
				this.errorMessages.transferAmount = 'Jumlah Transfer tidak valid';
			}
		},
		validateTransferEvidence() {
			this.errorMessages.transferEvidence = '';
			if (this.transferEvidence === null) {
				this.errorMessages.transferEvidence = 'Bukti Transfer wajib diisi';
			}
		},
		validateAllForms() {
			this.validateOrderId();
			this.validateBankOwnerName();
			this.validateBankAcount();
			this.validateTransferDate();
			this.validateTransferAmount();
			this.validateTransferEvidence();
		},
		checkFeature() {
			if (this.user) {
				const isAllowed = this.isDropshipper;
				if (!isAllowed) {
					this.$router.replace('/');
				}
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isHasFeature: 'isHasFeature',
			isDropshipper: 'isDropshipper',
		}),
		privateOrderId() {
			return this.privateOrder?._id.$oid ?? this.privateOrder?._id;
		},
		orderId() {
			return this.privateOrder?.order_id ?? '';
		},
		transferAmount() {
			return this.privateOrder?.total_price ?? '';
		},
		formatBankAccount() {
			return `${this.bankAccount.label} - ${this.bankAccount.account_name} - ${this.bankAccount.account_number}`;
		},
		transferEvidenceSize() {
			const fileSize = this.transferEvidence?.size ?? 0;
			return formatFileSize(fileSize);
		},
	},
	watch: {
		user() {
			this.checkFeature();
		},
	},
	mounted() {
		this.checkFeature();
		this.getPrivateOrder();
	},
};
</script>

<style scoped lang="scss">
.title {
	font-weight: 700;
	color: black;
}

.card {
	.form-control {
		background-color: #fff;
	}

	.form-control:disabled {
		background-color: #e9ecef;
		opacity: 1;
	}
}

textarea {
  field-sizing: content;
}

.mb-50 {
	margin-bottom: 50px;
}

.step-title {
	font-size: 24px;
	width: 50px;
	height: 50px;
	border: 1px solid #D9DADD;
	border-radius: 8px;
	font-weight: 700;
}

.step-line {
	height: 100%;
	border-left: 1px solid #D9DADD;
	position: absolute;
	top: 50px;
}
</style>
